<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>属性管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="属性名称">
          <el-input v-model="listQuery.propertyName" placeholder="请输入属性名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="属性描述">
          <el-input v-model="listQuery.propertyDesc" placeholder="请输入属性描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="输入方式">
          <el-select v-model="listQuery.inputType" clearable placeholder="请选择输入方式">
            <el-option label="输入" :value="0"></el-option>
            <el-option label="选择" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="listQuery.timePart"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="addAttr">新增属性</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

        <el-table-column prop="propertyName" label="属性名称" fixed="left"></el-table-column>
        <el-table-column prop="propertyDesc" label="属性描述" width="300"></el-table-column>
        <el-table-column prop="status" label="输入方式">
          <template slot-scope="scope">
            <span v-if="scope.row.inputType==0">输入</span>
            <span v-if="scope.row.inputType==1">选择</span>
          </template>
        </el-table-column>
        <el-table-column prop="inputScope" label="属性范围"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="180px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="editAttr(scope.row)" size="mini">编辑</el-button>
            <el-button type="text" @click="delAttr(scope.row)" class="red" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!-- 新增属性 -->
    <el-dialog
      title="新增属性"
      :visible.sync="addAttrVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addAttrForm"
        :rules="addRules"
        label-width="140px"
        :model="addAttrForm"
        size="medium"
      >
        <el-row>
          <el-form-item label="属性名称" prop="propertyName">
            <el-input v-model="addAttrForm.propertyName" clearable placeholder="请输入属性名称"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="属性描述" prop="propertyDesc">
            <el-input v-model="addAttrForm.propertyDesc" clearable placeholder="请输入属性描述"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="输入类型" prop="inputType">
            <el-select v-model="addAttrForm.inputType" clearable placeholder="请选择输入类型">
              <el-option label="输入" :value="0"></el-option>
              <el-option label="选择" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="可选择的范围" prop="inputScope" v-if="addAttrForm.inputType==1">
            <el-input v-model="addAttrForm.inputScope" clearable placeholder="范围取值以逗号分割"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" addAttrVisible= false">取 消</el-button>
        <el-button type="primary" @click="confAddAttr('addAttrForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改属性 -->

    <el-dialog
      title="修改属性"
      :visible.sync="editAttrVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="editAttrForm"
        :rules="editRules"
        label-width="140px"
        :model="editAttrForm"
        size="medium"
      >
        <el-row>
          <el-form-item label="属性名称" prop="propertyName">
            <el-input v-model="editAttrForm.propertyName" clearable placeholder="请输入属性名称"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="属性描述" prop="propertyDesc">
            <el-input v-model="editAttrForm.propertyDesc" clearable placeholder="请输入属性描述"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="输入类型" prop="inputType">
            <el-select v-model="editAttrForm.inputType" clearable placeholder="请选择输入类型">
              <el-option label="输入" :value="0"></el-option>
              <el-option label="选择" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="可选择的范围" prop="inputScope" v-if="editAttrForm.inputType==1">
            <el-input v-model="editAttrForm.inputScope" clearable placeholder="范围取值以逗号分割"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" editAttrVisible= false">取 消</el-button>
        <el-button type="primary" @click="confEditAttr('editAttrForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
export default {
  components: { Pagination },
  data() {
    return {
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        propertyName: "",
        propertyDesc: "",
        inputType: "",
        timePart: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      addAttrVisible: false,
      addAttrForm: {
        propertyName: "",
        propertyDesc: "",
        inputType: 0,
        inputScope: ""
      },
      addRules: {
        inputType: [
          { required: true, message: "请选择输入类型", trigger: "change" }
        ],
        propertyName: [
          { required: true, message: "请输入属性名称", trigger: "change" }
        ],
        propertyDesc: [
          { required: true, message: "请输入属性描述", trigger: "change" }
        ],
        inputScope: [
          { required: true, message: "请输入可选择的范围", trigger: "change" }
        ]
      },
      attrInfo: {},
      editAttrVisible: false,
      editAttrForm: {
        propertyName: "",
        propertyDesc: "",
        inputType: 0,
        inputScope: ""
      },
      editRules: {
        inputType: [
          { required: true, message: "请选择输入类型", trigger: "change" }
        ],
        propertyName: [
          { required: true, message: "请输入属性名称", trigger: "change" }
        ],
        propertyDesc: [
          { required: true, message: "请输入属性描述", trigger: "change" }
        ],
        inputScope: [
          { required: true, message: "请输入可选择的范围", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        page: this.currentPage,
        size: this.pageSize,
        propertyName: this.listQuery.propertyName,
        propertyDesc: this.listQuery.propertyDesc,
        inputType: this.listQuery.inputType
      };
      if (
        this.listQuery.timePart != "" &&
        this.listQuery.timePart != undefined
      ) {
        temp.createTimeStart = this.listQuery.timePart[0]
          .getTime()
          .toString()
          .substr(0, 10);
        temp.createTimeEnd = this.listQuery.timePart[1]
          .getTime()
          .toString()
          .substr(0, 10);
      }
      wmsApi
        .$axiosPropertyList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    delAttr(row) {
      this.$confirm(`确定删除该属性吗？`)
        .then(_ => {
          wmsApi
            .$axiosDeleteProperty({
              propertyId: row.id
            })
            .then(res => {
              this.$message.success(`删除成功！`);
              this.querySearch();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(_ => {});
      console.log(row);
    },
    addAttr() {
      this.addAttrVisible = true;
      this.addAttrForm = {
        propertyName: "",
        propertyDesc: "",
        inputType: 0,
        inputScope: ""
      };
    },
    confAddAttr(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            propertyName: this.addAttrForm.propertyName,
            propertyDesc: this.addAttrForm.propertyDesc,
            inputType: this.addAttrForm.inputType,
            inputScope:
              this.addAttrForm.inputType == 0
                ? ""
                : this.addAttrForm.inputScope
                    .replace(/[\s\r\n]/g, "")
                    .replace(/[，.。,]/g, ",")
          };

          wmsApi.$axiosAddNewProperties(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addAttrVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editAttr(row) {
      this.attrInfo = row;
      this.editAttrVisible = true;
      this.editAttrForm = {
        propertyName: row.propertyName,
        propertyDesc: row.propertyDesc,
        inputType: row.inputType,
        inputScope: row.inputScope
      };
    },
    confEditAttr(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.editAttrForm);
          let params = {
            propertyName: this.editAttrForm.propertyName,
            propertyDesc: this.editAttrForm.propertyDesc,
            inputType: this.editAttrForm.inputType,
            inputScope:
              this.editAttrForm.inputType == 0
                ? ""
                : this.editAttrForm.inputScope
                    .replace(/[\s\r\n]/g, "")
                    .replace(/[，.。,]/g, ","),
            id: this.attrInfo.id
          };
          console.log(params);

          wmsApi.$axiosUpdateProperty(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("修改成功");
              this.editAttrVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
>>> .el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>